/**
 * Patients Module
 */
import Vue from 'vue';
import router from '../../../router/router';
import { apiModel, makeApiRequest } from "../../../api";
import Swal from "sweetalert2";
import {store} from "../../store";
// States
const state = {
    prescriptions: [],
    prescription: {}
};

// Getters
const getters = {
    prescriptions: state => {
        return state.prescriptions
    },

    prescription: state => {
        return state.prescription
    }
};

// Actions
const actions = {
    getPrescriptions(context, payload) {
        function successCallback(response) {
            context.commit('getPrescriptionsHandler', { prescriptions: response.data.ordonances });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Ordonance.List, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    getPrescription(context, payload) {
        function successCallback(response) {
            context.commit('getPrescriptionHandler', { prescription: response.data.ordonance });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Ordonance.Get, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    createPrescription(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );
            if(response.data.hasOwnProperty('message')){
                Swal.fire(
                    response.data.message,
                    '',
                    'warning'
                );
            }
            router.push({ name: 'prescription', params: { prescription: response.data.ordonance.slug } });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Ordonance.Create, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    updatePrescription(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );
            store.dispatch('findAndRemove', {name: 'prescription' });
            router.push({ name: 'prescription', params: { patient: response.data.ordonance.slug } });
            // router.push({ name: 'patients' });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Ordonance.Update, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    deletePrescription(context, payload) {
        function successCallback(response) {
            // context.commit('deletePrescriptionHandler', { index: payload.index, successMessage: payload.successMessage });
            router.push((router.resolve({ name: 'medical-file',  params: { file: response.data.ordonance.dossier.slug } }).href) +"#prescriptions");

        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Ordonance.Delete, localToken, successCallback, errorCallback, payload.errorMessages);
    },
};

// Mutations
const mutations = {
    getPrescriptionsHandler(state, { prescriptions }) {
        // Update patients state
        state.prescriptions = prescriptions;
    },

    getPrescriptionHandler(state, { prescription }) {
        // Update patient state
        state.prescription = prescription;
    },

    deletePrescriptionHandler(state, { index, successMessage }) {
        // let i = state.patients.findIndex(patient => patient.slug === index);

        // if (~i) {
        //     state.patients.splice(i, 1);
        // router.push({ name: 'prescriptions' });

        Vue.swal(
            successMessage,
            '',
            'success'
        );
        // }
    }
};

export default {
    state,
    getters,
    actions,
    mutations
}